import { all } from 'redux-saga/effects';
import App from './ducks/app/saga';
import Persistent from './ducks/persistent/saga';

export default function* rootSaga() {
    yield all([].concat(App()).concat(Persistent()))
};

